import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'

import { destinationEnum } from '../../../data/models/funnelOrder/destination'
import {
  getIncoming,
  getOutgoing,
  IncomingTime,
  OutgoingTime,
} from '../../../data/models/funnelOrder/times'
import { AppState } from '../../../data/state'

interface TimesSummaryProps {
  destination: destinationEnum
  outgoingTime: OutgoingTime
  incomingTime: IncomingTime
  loading: boolean
  bold?: boolean
}

const TimesSummary: React.FC<TimesSummaryProps> = ({
  destination,
  outgoingTime,
  incomingTime,
  loading,
  bold,
}) => {
  if (destination === destinationEnum.outsideEurope) {
    return null
  }
  const loadingClass =
    (loading ? 'is-loading' : '') + (bold ? ' text-bold' : '')
  return (
    <ListItem>
      <span className={loadingClass}>
        <DisplayContent contentKey="outward-summary" addNode={false}>
          Outgoing
        </DisplayContent>
        {`: `}
        {getOutgoing(outgoingTime)}
        {` / `}
        <DisplayContent contentKey="return-summary" addNode={false}>
          Return
        </DisplayContent>
        {` : `}
        {getIncoming(incomingTime)}
      </span>
    </ListItem>
  )
}

export default connect((state: AppState) => ({
  destination: state.funnelOrder.destination,
  outgoingTime: state.funnelOrder.outgoingTime,
  incomingTime: state.funnelOrder.incomingTime,
  loading: state.contentEngine.loading,
}))(TimesSummary)
